import type { QueryApi } from "../../api/query";

export function createUseLatestDiscountCodes($api: QueryApi) {
  return function useLatestDiscountCodes(options?: { enabled?: boolean }) {
    return $api.useQuery("get", "/discount-codes/latest", {}, {
      staleTime: 60_000,
      ...options,
    });
  };
}
